import {Injectable} from "@angular/core";
import {IContainerAsideComponent} from "../../shared/interfaces/configuracion";


@Injectable({providedIn: 'root'})
export abstract class MasterAsideService {
  abstract getMenuItems(translation:any, isLoggedIn:boolean, props?:any): IContainerAsideComponent[];
}
